import React from 'react';
import { Link } from 'react-router-dom';
import tailTraceIcon from '../assets/updateLogo.png';
import './footer.css';

const Footer = () => {
  return (
    <footer className="footerContainer">
      <div className="footerTop">
        <Link to="/" className="logoLink">
          <img className="tailTraceIconFooter" src={tailTraceIcon} alt="TailTrace Logo" />
        </Link>
        <div className="footerLinks">
          <Link to="/about" className="footerLink">About</Link>
          <Link to="/contact" className="footerLink">Contact</Link>
          <a href="https://www.instagram.com/tailtracehq/?igsh=NTc4MTIwNjQ2YQ%3D%3D&utm_source=qr#"
             target="_blank"
             rel="noopener noreferrer"
             className="footerLink">Instagram</a>
          <Link to="/terms" className="footerLink">Terms</Link>
        </div>
      </div>
      <p className="footerCopyright">
        © {new Date().getFullYear()} TailTrace. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
